<template>
  <div class="responsive-logo-trigger">
    <div v-if="!isMobile" class="menu-start">
      <div class="menu-start-icon" @click="navigateHome" />
    </div>
    <button
      v-else
      type="button"
      class="responsive-navigation-burger-button"
      :class="{ open: isMobilNavigationOpen }"
      @click="toggleResponsiveNavigation()"
    >
      <span />
      <span />
      <span />
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters("menu", ["isNavigationCollapsed"]),
    ...mapGetters("dom", ["isMobile"]),
    isMobilNavigationOpen() {
      return this.isMobile && !this.isNavigationCollapsed;
    }
  },
  methods: {
    ...mapActions("menu", ["setNavigationCollapsed"]),
    toggleResponsiveNavigation() {
      this.setNavigationCollapsed(!this.isNavigationCollapsed);
    },
    navigateHome() {
      this.$router.push({
        name: "main",
        query: {
          ...this.$route.query,
          // NavigationDuplicated Error wird durch einen kompletten reload der main- Komponente verhindert
          _forceNav: new Date().getTime()
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.responsive-logo-trigger {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.75rem;
  background-color: var(--ci-alpha-bg, #d4003c);
  border-bottom: 0.125rem solid;
  border-color: var(--ci-alpha-color, #fff);
  height: 56px;
  width: 56px;
  & > button {
    outline: none;
  }
}
.menu-start-icon {
  background-image: url(../assets/logo_dots.svg);
  background-repeat: no-repeat;
  height: 30px;
  width: 30px;
}

.menu-start-icon:hover {
  cursor: pointer;
}

$navigation-burger-button-base: 8px !default;
.responsive-navigation-burger-button {
  width: 25px;
  height: 25px;
  position: relative;
  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  cursor: pointer;
  span {
    display: block;
    position: absolute;
    height: 3px;
    width: 100%;
    background: white;
    border-radius: 9px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;

    &:nth-child(1) {
      top: 0px;
    }
    &:nth-child(2) {
      top: $navigation-burger-button-base;
    }
    &:nth-child(3) {
      top: $navigation-burger-button-base * 2;
    }
  }
  &.open span:nth-child(1) {
    top: $navigation-burger-button-base;
    transform: rotate(135deg);
  }
  &.open span:nth-child(2) {
    opacity: 0;
    left: -60px;
  }

  &.open span:nth-child(3) {
    top: $navigation-burger-button-base;
    transform: rotate(-135deg);
  }
}
</style>
